// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.PatientPhoneInformationRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientPhoneInformationRequest extends GandalfModelBase {

	@GandalfLabel('Cell phone number')
	@GandalfValidator({ sizeString: { message: 'Cell phone number cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfValidator({ phoneNumber: { message: 'Cell phone number must contain at least 10 digits' } })
	@GandalfProperty({ designType: String })
	cellPhone!: string | null;

	@GandalfLabel('Cell phone extension')
	@GandalfValidator({ sizeString: { message: 'Cell phone extension cannot be longer than 10 characters', minLength: 0, maxLength: 10 } })
	@GandalfProperty({ designType: String })
	cellPhoneExtension!: string | null;

	@GandalfLabel('Email')
	@GandalfValidator({ sizeString: { message: 'Email cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfValidator({ email: { message: 'Invalid email format' } })
	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfLabel('Email Declined')
	@GandalfProperty({ designType: Boolean })
	emailDeclined!: boolean | null;

	@GandalfLabel('Home phone number')
	@GandalfValidator({ sizeString: { message: 'Home phone number cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfValidator({ phoneNumber: { message: 'Home phone number must contain at least 10 digits' } })
	@GandalfProperty({ designType: String })
	homePhone!: string | null;

	@GandalfLabel('Home phone extension')
	@GandalfValidator({ sizeString: { message: 'Home phone extension cannot be longer than 10 characters', minLength: 0, maxLength: 10 } })
	@GandalfProperty({ designType: String })
	homePhoneExtension!: string | null;

	@GandalfLabel('Pager')
	@GandalfValidator({ sizeString: { message: 'Pager cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfProperty({ designType: String })
	pager!: string | null;

	@GandalfConstantDecorator(constants.PreferredPhoneType)
	@GandalfLabel('Preferred Phone Type')
	@GandalfValidator({ notNull: { message: 'Preferred Phone Type is required' } })
	@GandalfProperty({ designType: constants.PreferredPhoneType, isRequired: true })
	preferredPhoneType!: constants.PreferredPhoneType;

	@GandalfLabel('Work phone number')
	@GandalfValidator({ sizeString: { message: 'Work phone number cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfValidator({ phoneNumber: { message: 'Work phone number must contain at least 10 digits' } })
	@GandalfProperty({ designType: String })
	workPhone!: string | null;

	@GandalfLabel('Work phone extension')
	@GandalfValidator({ sizeString: { message: 'Work phone extension cannot be longer than 10 characters', minLength: 0, maxLength: 10 } })
	@GandalfProperty({ designType: String })
	workPhoneExtension!: string | null;

}
